import { StandardViewModel } from '@/api';
import { StandardResponse } from '@/api/api-client';

export const mapStandards = (data: StandardResponse[]): StandardViewModel[] => {
  return data.map(item => ({
    id: item.id,
    name: item.name,
    version: item.version,
    group: item.group,
  }));
};